
import ttiPolyfill from 'tti-polyfill'

import {createLogger} from 'logging'
const logger = createLogger('PerformanceMeasurement')

//you must ensure your PerformanceObserver is registered in the <head> of your document
//before any stylesheets, so it runs before FP/FCP happens.
import {isNewRelicAvailable} from 'powtoon-commons/utils'
export default class PerformanceMeasurement {

  constructor(biTracker, {enableBiEvent = false} = {}){
    this.biTracker = biTracker
    this.enableBiEvent = enableBiEvent
  }

  checkConsistentlyInteractive({codeLabel, performanceEventID, extraParams = {}}) {
    const operationLabel = `Action Cost Time to Interactive - ${codeLabel}`
    const deltaFromPerformanceNow = Date.now() - performance.timing.domContentLoadedEventStart
    ttiPolyfill.getFirstConsistentlyInteractive().then((tti) => {

      const title = 'Operation measurement'
      const operationTimeInMiliseconds = tti - deltaFromPerformanceNow
      if (operationTimeInMiliseconds > 0){
        const record = {operationLabel, operationTimeInMiliseconds, ...extraParams}
        logger.performanceLog(title, record)

        if (isNewRelicAvailable()) {
          //https://bam.nr-data.net
          window.newrelic.addPageAction(title, {
            operationTimeInMiliseconds,
            operationLabel
          })
        }

        this.#sendBiPerformanceReport({
          operationLabel,
          operationTimeInMiliseconds,
          extraParams,
          performanceEventID
        })
      }
    })
  }

  operationMeasurement = ({
    operationLabel,
    performanceEventID,
    measureFromStartOfNavigationTillNow = false,
    extraParams = {}
  }) => {
    const startTime = Date.now()
    const title = 'Operation measurement'
    let isExecuted = false
    const timeLabel = `${operationLabel}`
    if (measureFromStartOfNavigationTillNow){
      performance.measure(timeLabel)
      const operationTimeInMiliseconds = Date.now() - performance.timing.navigationStart
      const record = {operationLabel: timeLabel, operationTimeInMiliseconds, ...extraParams}

      logger.performanceLog(title, record)

      this.#sendBiPerformanceReport({
        operationLabel,
        operationTimeInMiliseconds,
        extraParams,
        performanceEventID
      })
      return null
    } else {
      performance.mark(operationLabel)
    }
    return (detailedOperationLabel= null) => {
      if (isExecuted) {
        logger.warn('This timer was called more than once')
        return
      }
      isExecuted = true
      const newTimelabel = `${detailedOperationLabel || operationLabel}`
      if (!measureFromStartOfNavigationTillNow){
        performance.measure(newTimelabel, operationLabel)
      }

      const endTime = Date.now()
      const operationTimeInMiliseconds = endTime - startTime
      const record = {operationLabel: newTimelabel, operationTimeInMiliseconds}

      logger.performanceLog(title, record)
      console.debug('*** operationMeasurement', title, newTimelabel, operationTimeInMiliseconds, performanceEventID)
      this.#sendBiPerformanceReport({
        operationLabel: newTimelabel,
        operationTimeInMiliseconds,
        extraParams,
        performanceEventID
      })
    }
  }
  
  //naming convention for private method see https://github.com/tc39/proposal-private-methods
  #sendBiPerformanceReport = ({operationLabel, operationTimeInMiliseconds, extraParams, performanceEventID}) => {
    const app_versions = window.app_versions? window.app_versions : null
    
    const log = {
      category: 'Operation measurement',
      action: operationLabel,
      extraData: {
        operationTimeInMiliseconds,
        ...extraParams,
        ...app_versions
      },
      value: performanceEventID
    }
    
    if (this.enableBiEvent && performanceEventID){
      this.biTracker.reportCustomEvent(log)
    }
  }
}